import { createCheckDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: createCheckDepositSlice, asyncAction: createCheckDepositAction } = createAsyncSlice(
  'createCheckDepositSlice',
  createCheckDepositAsync
);
